import type { Camera } from '../engine/Camera';
import type { ToastSystem } from '../effects/Toasts';

/**
 * Renders floating eat toasts.
 *
 * Style:
 *   - text colored to the pellet hue
 *   - perfect-match toasts get a bigger size + glow shadow + a subtle
 *     leading "★" accent so 3× eats read instantly
 *   - alpha follows life / maxLife (linear fade)
 */
export class ToastRenderer {
  draw(ctx: CanvasRenderingContext2D, camera: Camera, system: ToastSystem): void {
    const z = camera.zoom;
    const cx = camera.viewportW * 0.5 + camera.shakeX;
    const cy = camera.viewportH * 0.5 + camera.shakeY;
    const cax = camera.position.x;
    const cay = camera.position.y;

    ctx.save();
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';

    system.forEachAlive((t) => {
      const sx = (t.x - cax) * z + cx;
      const sy = (t.y - cay) * z + cy;
      const alpha = Math.max(0, Math.min(1, t.life / t.maxLife));
      const baseColor = `hsl(${t.hue} 100% 78%)`;
      ctx.globalAlpha = alpha;

      if (t.perfect) {
        ctx.shadowColor = baseColor;
        ctx.shadowBlur = 14;
        ctx.font = '700 14px "Space Grotesk", system-ui, sans-serif';
        ctx.fillStyle = baseColor;
      } else {
        ctx.shadowColor = baseColor;
        ctx.shadowBlur = 6;
        ctx.font = '600 11px "Space Grotesk", system-ui, sans-serif';
        ctx.fillStyle = baseColor;
      }
      ctx.fillText(t.text, sx, sy);
    });

    ctx.restore();
    ctx.globalAlpha = 1;
  }
}
